import { HelperService } from '../services/helper.service'

export interface IAnalysisRcaFilterModel {
  sites?: string[]
  tagName?: string
  rcaNo?: string
  title?: string
  active?: number
}

export class AnalysisRcaFilterModel implements IAnalysisRcaFilterModel {
  public sites?: string[]
  public tagName?: string
  public rcaNo?: string
  public title?: string
  public active?: number

  constructor(model?: IAnalysisRcaFilterModel) {
    if (model) {
      Object.assign(this as IAnalysisRcaFilterModel, model)
    }
  }

  public static fromJson(json: IAnalysisRcaFilterModel): AnalysisRcaFilterModel {
    const _object: AnalysisRcaFilterModel = new AnalysisRcaFilterModel()

    _object.sites = json.sites && json.sites.length > 0 ? json.sites : null
    _object.tagName = json.tagName && json.tagName.length > 0 ? json.tagName : null
    _object.rcaNo = json.rcaNo && json.rcaNo.length > 0 ? json.rcaNo : null
    _object.title = json.title && json.title.length > 0 ? json.title : null
    _object.active = !HelperService.isNullOrUndefined(json.active) ? json.active : null

    return _object
  }

  public toJson(): any {
    const _json: any = {}
    if (this.tagName && this.tagName.length > 0) {
      _json['tagName'] = this.tagName
    }
    if (this.rcaNo && this.rcaNo.length > 0) {
      _json['rcaNo'] = this.rcaNo
    }
    if (this.title && this.title.length > 0) {
      _json['title'] = this.title
    }
    if (!HelperService.isNullOrUndefined(this.active)) {
      _json['active'] = this.active
    }
    if (this.sites && this.sites.length > 0) {
      _json['sites'] = this.sites
    }
    return _json
  }
}

export class AnalysisRcaFilterMapModel {
  public sites: string = 'Sites'
  public tagName: string = 'Tagname'
  public rcaNo: string = 'RCA No'
  public title: string = 'Title'
  public active: string = 'Active'
}

export class FaultAnalysisRcaFilterMapModel extends AnalysisRcaFilterMapModel {
  public rcaNo: string = 'RCA Fault No'
}

export class DemandAnalysisRcaFilterMapModel extends AnalysisRcaFilterMapModel {
  public rcaNo: string = 'RCA Demand No'
}

export class OverrideAnalysisRcaFilterMapModel extends AnalysisRcaFilterMapModel {
  public rcaNo: string = 'RCA Demand No'
}
